/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Agents_Mock_LimitInputs */

const en_cap_agents_mock_limit = /** @type {(inputs: Cap_Agents_Mock_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`max`)
};

const lv_cap_agents_mock_limit = /** @type {(inputs: Cap_Agents_Mock_LimitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`līdz`)
};

/**
* | output |
* | --- |
* | "max" |
*
* @param {Cap_Agents_Mock_LimitInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_agents_mock_limit = /** @type {((inputs?: Cap_Agents_Mock_LimitInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Agents_Mock_LimitInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_agents_mock_limit(inputs)
	return en_cap_agents_mock_limit(inputs)
});